import { useRef, useEffect } from 'react';

export default function useEffectOnInitialize(callback: () => void) {
  const initialized = useRef<boolean>(false);

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      callback();
    }
  }, [callback]);
}
